import { create } from 'zustand';
import { immer } from 'zustand/middleware/immer';

export interface ThreatOverlayPoint {
  target: string;           // node ID this threat applies to
  score: number;            // 0-100
  feeds: string[];          // which feeds flagged this
  label: string;            // human-readable summary
  source: string;           // adapter id ('darkapi' | 'threatdefense')
  color?: string;           // optional override color
  category?: string;        // 'malware' | 'botnet' | 'phishing' | 'c2' | 'scanner'
  confidence?: number;      // 0-1
  // DarkAPI first-party enriched fields
  threatLevel?: string;     // 'none' | 'low' | 'medium' | 'high' | 'critical'
  feedDetails?: Record<string, Record<string, unknown>>;
  lastSeen?: string;        // ISO timestamp
}

interface OverlayDataState {
  points: Record<string, ThreatOverlayPoint[]>;
}

interface OverlayDataActions {
  setPoints: (adapterId: string, points: ThreatOverlayPoint[]) => void;
  clearPoints: (adapterId: string) => void;
  clearAll: () => void;
}

export const useOverlayDataStore = create<OverlayDataState & OverlayDataActions>()(
  immer((set) => ({
    points: {},

    setPoints: (adapterId, points) =>
      set((state) => {
        state.points[adapterId] = points;
      }),

    clearPoints: (adapterId) =>
      set((state) => {
        delete state.points[adapterId];
      }),

    clearAll: () =>
      set((state) => {
        state.points = {};
      }),
  })),
);
